







































import { Component, Mixins, Prop, Provide, Watch } from 'vue-property-decorator';
import { SeriesOptionsTypeExtended, TChart } from '@/plugins/podolib/services/helper/mixins/chart';
import MixinCharts from '@/plugins/podolib/services/helper/mixins/chart/standard';

@Component({
  components: {
    ChartRunningPhaseResume: () => import('@/components/charts/running/ChartRunningPhaseResume.vue'),
    ChartRunningPhaseComparisonTable: () => import('@/components/charts/running/ChartRunningPhaseComparisonTable.vue'),
    ChartRunningPhaseGlobalBanner: () => import('@/components/charts/running/ChartRunningPhaseGlobalBanner.vue'),
  },
})
export default class ChartRunningPhaseDetailed extends Mixins(MixinCharts) implements TChart {
  @Prop({ default: false }) acquisitionTreadmill!: boolean | number;
  @Prop({ default: false }) isNewAnalysis!: boolean;
  // Chart name for exportation
  readonly name = 'ChartRunningPhaseDetailed';
  infos: any = null;
  compareData: any = [];
  symmetry: any = [];

  /*plotLines: any = {
    lines: {
      height: 175,
      width: 2
    },
    rects: {
      height: 18,
      width: 40,
      radius: 3
    },
    first: {
      index: 0,
      active: false,
      color: '#FFBD19',
      line: null,
      rect: null,
      text: ''
    },
    second: {
      index: 1,
      active: false,
      color: '#FF9901',
      line: null,
      rect: null,
      text: ''
    }
  };*/
  plotLines: any = {
    lines: {
      height: 175,
      width: 3,
    },
    first: {
      index: 0,
      active: false,
      color: '#FFBD19',
      line: null,
    },
    second: {
      index: 1,
      active: false,
      color: '#FF9901',
      line: null,
    },
  };

  get segments() {
    /*const data = this.values.segments.filter(
      (x: any) => x.left.aggregates.stance_time.avg !== 0 && x.right.aggregates.stance_time.avg !== 0
    );*/
    return this.values.segments;
  }
  // Data
  get speed() {
    let data: any = [];
    this.segments.forEach((item: any, idx: number) => {
      data.push([
        this.getDuration(idx),
        (item.left.result.aggregates.running_speed.avg + item.right.result.aggregates.running_speed.avg) / 2,
      ]);
    });
    return data;
  }
  get cadence() {
    let data: any = [];
    this.segments.forEach((item: any, idx: number) => {
      data.push([
        this.getDuration(idx),
        item.left.result.aggregates.cadence.avg + item.right.result.aggregates.cadence.avg,
      ]);
    });
    return data;
  }
  // Chart
  get _val(): SeriesOptionsTypeExtended[] {
    return [
      // @ts-ignore
      {
        id: 'Speed',
        name: this.$t('commons.standards.speed') as string,
        data: this.speed,
        zones: [],
        type: 'areaspline',
        shadow: true,
        color: '#3F91DF',
        yAxis: 0,
        zIndex: 2,
        marker: {
          symbol: 'circle',
          lineWidth: 1.5,
        },
      },
      // @ts-ignore
      {
        id: 'Cadence',
        name: this.$t('commons.standards.cadence') as string,
        data: this.cadence,
        zones: [],
        type: 'areaspline',
        shadow: true,
        color: '#6E768D',
        yAxis: 1,
        marker: {
          enabled: false,
          symbol: 'circle',
          lineWidth: 1.5,
        },
      },
    ];
  }
  get series() {
    return [...this._val];
  }

  @Watch('values', { deep: true, immediate: true })
  onValuesChange() {
    // Remove plot lines on values change
    const _chart = this.$hc.charts.find((x) => x && x.options.title!.text === 'Speed / Cadence');
    const chart = _chart ? _chart!.xAxis[0] : null;
    if (chart) {
      chart.removePlotLine('first');
      chart.removePlotLine('second');
    }
    this.compareData = [];
    this.setData();
  }

  getDuration(idx: number) {
    let globalSpeed =
      this.segments[idx]?.left && this.segments[idx]?.right
        ? (this.segments[idx]?.left.header.start_time + this.segments[idx]?.right.header.start_time) / 2
        : null;
    return !globalSpeed
      ? 0
      : (this.$moment as any)
          .duration({
            seconds: globalSpeed / 32768,
          })
          .asMilliseconds();
  }
  // Set chart
  created() {
    this.setData();
  }
  setData() {
    let _this = this;
    this.setOptions({
      chart: {
        height: 250,
      },
      // @ts-ignore
      title: {
        text: 'Speed / Cadence',
        style: {
          color: 'transparent',
          // @ts-ignore
          fontSize: 0,
        },
        margin: 0,
      },
      xAxis: {
        labels: {
          formatter() {
            // @ts-ignore
            return _this.$moment.utc(this.value).format('mm:ss');
          },
        },
        crosshair: {
          width: 60,
          color: 'rgba(206,214,217,0.5)',
        },
      },
      yAxis: [
        {
          labels: {
            format: `{value}`,
          },
          title: {
            text: _this.$t('commons.standards.speed') + ' (km/h)',
          },
          min: 0,
          // @ts-ignore
          maxZoom: 20,
        },
        {
          opposite: true,
          labels: {
            // @ts-ignore
            align: 'left',
            format: `{value}`,
          },
          title: {
            text: _this.$t('commons.standards.cadence') + ' (' + _this.$t('commons.units.steps-min') + ')',
            margin: 20,
          },
          // @ts-ignore
          maxZoom: 75,
        },
      ],
      plotOptions: {
        areaspline: {
          lineWidth: 3,
          fillColor: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1,
            },
            stops: [
              [0, 'rgba(186,204,215,0.4)'],
              [1, 'rgba(255,255,255,0.1)'],
            ],
          },
        },
        series: {
          cursor: 'pointer',
          point: {
            events: {
              click(event) {
                const _chart = _this.$hc.charts.find((x) => x && x.options.title!.text === 'Speed / Cadence');

                // @ts-ignore
                let index = this.index;
                const that: any = this;
                /*function drawPlotLine(type: string) {
                  const margin = 63; // Don't touch to this value - need it to have good point position - I don't know why this value but it's working
                  const x = that.plotX + margin;

                  _this.plotLines[type].active = true;
                  // Set line
                  _this.plotLines[type].line = _chart!.renderer
                    .rect(x, 0, _this.plotLines.lines.width, _this.plotLines.lines.height)
                    .attr({
                      fill: _this.plotLines[type].color,
                      zIndex: 2
                    })
                    .add();
                  // Set rect
                  _this.plotLines[type].rect = _chart!.renderer
                    .rect(
                      x - _this.plotLines.rects.width / 2,
                      175,
                      _this.plotLines.rects.width,
                      _this.plotLines.rects.height,
                      _this.plotLines.rects.radius
                    )
                    .attr({
                      fill: _this.plotLines[type].color,
                      zIndex: 7
                    })
                    .add();
                  // Set text
                  _this.plotLines[type].text = _chart!.renderer
                    .text(_this.$moment.utc(_this.getDuration(index)).format('mm:ss'), x, 188)
                    .attr({
                      zIndex: 7,
                      align: 'center'
                    })
                    .add();
                }
                function removePlotLine(type: string) {
                  console.log('removePlotLine')
                  if (_this.plotLines[type].active) {
                    _this.plotLines[type].active = false;
                    _this.plotLines[type].line.element.remove();
                    _this.plotLines[type].rect.element.remove();
                    _this.plotLines[type].text.element.remove();
                  }
                }
                function removeAllPlotLine() {
                  console.log('removeAllPlotLine')
                  removePlotLine('first');
                  removePlotLine('second');
                }*/

                function drawPlotLine(type: string) {
                  if (type === 'first') removeAllPlotLine();
                  const chart = _chart!.xAxis[0];
                  _this.plotLines[type].line = chart.addPlotLine({
                    value: that.x,
                    color: _this.plotLines[type].color,
                    width: _this.plotLines.lines.width,
                    id: type,
                  });
                }
                function removePlotLine(type: string) {
                  const chart = _chart!.xAxis[0];
                  chart.removePlotLine(type);
                }
                function removeAllPlotLine() {
                  removePlotLine('first');
                  removePlotLine('second');
                }

                // Show on chart
                if (_chart) {
                  // Always keep two values
                  if (_this.compareData.length >= 2) {
                    _this.compareData.length = [];
                    for (const p of _chart.series[0].data) {
                      p.update({
                        marker: {
                          fillColor: '#FFFFFF',
                          lineColor: '#3F91DF',
                          lineWidth: 2,
                        },
                      });
                    }
                  }

                  // Init values text / line
                  if (_this.compareData.length === 0 && _this.plotLines.first.active && _this.plotLines.first.active) {
                    removeAllPlotLine();
                  }
                  // Add first values text / line
                  if (_this.compareData.length === 0) {
                    drawPlotLine('first');
                  }
                  // Add second values text / line
                  if (_this.compareData.length === 1) {
                    drawPlotLine('second');
                  }

                  // Add point
                  _this.compareData.push({
                    index: index,
                    y: this.y,
                    x: this.x,
                    indexPosition: _this.compareData.length,
                  });

                  // If the same point is selected
                  if (_this.compareData.length >= 2 && _this.compareData[0].index === _this.compareData[1].index) {
                    _this.compareData = [];
                    removeAllPlotLine();
                    for (const p of _chart.series[0].data) {
                      p.update({
                        marker: {
                          fillColor: '#3F91DF',
                        },
                      });
                    }
                  }

                  // Add stylling point
                  if (_this.compareData.length >= 1) {
                    // @ts-ignore
                    let i = 0;
                    for (const p of _chart.series[0].data) {
                      if (_this.getDuration(_this.compareData[0].index) === p.x) {
                        p.update({
                          marker: {
                            fillColor: '#ffffff',
                            lineColor: '#3F91DF',
                            lineWidth: 8,
                          },
                        });
                        // If there are two elements in compareData && indentical index
                      } else if (_this.compareData[1] && _this.getDuration(_this.compareData[1].index) === p.x) {
                        p.update({
                          marker: {
                            fillColor: '#ffffff',
                            lineColor: '#3F91DF',
                            lineWidth: 8,
                          },
                        });
                      } else {
                        p.update({
                          marker: {
                            fillColor: '#3F91DF',
                          },
                        });
                      }
                      i++;
                    }
                  }
                }

                // Sort compareData by Index
                _this.compareData.sort((a: any, b: any) => {
                  return a.index - b.index;
                });

                // Implement zones when select
                if (_this.compareData.length >= 2) {
                  // Initialize
                  // @ts-ignore
                  _chart.series[0].update({
                    zones: [],
                  });
                  // @ts-ignore
                  _chart.series[0].update({
                    zoneAxis: 'x',
                    zones: [
                      {
                        value: _this.compareData[0].x,
                        color: '#3F91DF',
                        fillColor: {
                          linearGradient: {
                            x1: 0,
                            y1: 0,
                            x2: 0,
                            y2: 1,
                          },
                          stops: [
                            [0, 'rgba(198,221,250,0.4)'],
                            [1, 'rgba(255,255,255,0.1)'],
                          ],
                        },
                      },
                      {
                        value: _this.compareData[1].x,
                        color: '#3F91DF',
                        fillColor: {
                          linearGradient: {
                            x1: 0,
                            y1: 0,
                            x2: 0,
                            y2: 1,
                          },
                          stops: [
                            [0, 'rgb(198,221,250)'],
                            [1, 'rgba(198,221,250,0.7)'],
                          ],
                        },
                      },
                      {
                        color: '#3F91DF',
                        fillColor: {
                          linearGradient: {
                            x1: 0,
                            y1: 0,
                            x2: 0,
                            y2: 1,
                          },
                          stops: [
                            [0, 'rgba(198,221,250,0.4)'],
                            [1, 'rgba(255,255,255,0.1)'],
                          ],
                        },
                      },
                    ],
                  });
                } else {
                  // @ts-ignore
                  _chart.series[0].update({
                    zones: [],
                  });
                }
              },
            },
          },
          shadow: true,
          marker: {
            states: {
              select: {
                enabled: false,
              },
            },
          },
        },
      },
      legend: {
        useHTML: true,
        layout: 'horizontal',
        squareSymbol: false,
        symbolHeight: 4,
        symbolWidth: 16,
        symbolRadius: 2,
        symbolPadding: 10,
        itemStyle: {
          lineHeight: '20px',
          color: '#6e768d',
          fontFamily: 'Open Sans',
          fontSize: '12px',
          fontWeight: '700',
        },
        align: 'center',
        verticalAlign: 'bottom',
        floating: false,
        // @ts-ignore
        style: {
          zIndex: 2,
        },
        x: 0,
        y: 0,
      },
      tooltip: {
        distance: 50,
        // @ts-ignore
        crosshairs: true,
        shared: true,
        followPointer: true,
        formatter: function () {
          let s = `<span style="font-size: 15px;">${_this.$moment
            // @ts-ignore
            .utc(_this.getDuration(this.points![0].point!.index))
            .format('mm:ss')} min </span>`;
          s += `<span style="font-size: 13px; color:grey">${_this.$moment
            // @ts-ignore
            .utc(_this.getDuration(this.points![0].point!.index))
            .format('SS')} ms</span>`;
          s += `<br/><span>-</span><br/>`;
          for (const p of this.points!) {
            const isCadence = p.series.name === _this.$t('commons.standards.cadence');
            s += `<span style="font-size: 13px; font-weight: bold; color: ${p.color}">${
              p.series.name
            } : ${p.point.y!.toFixed(isCadence ? 0 : 1)} ${
              isCadence ? _this.$t('commons.units.steps-min') : 'km/h'
            }</span>`;
            s += `<br/>`;
          }
          return s;
        },
      },
      series: [],
    });
    this.setSeries(this.series);
  }
}
